module.exports = __webpack_public_path__ + "static/media/logo_gorila.4a5b49b6.svg";